import { Component } from 'react';
import { connect } from 'react-redux';
import { listenOnMediaQuery } from 'utils/domUtils';
import bindActions, { types as ats } from '../../actions';

export class ResponsiveWidthMonitor extends Component {
  componentDidMount() {
    const result = listenOnMediaQuery(this.props.query, (e) => this.updateIsResponsiveWidth(e.matches));

    this.updateIsResponsiveWidth(result.matches);
  }

  updateIsResponsiveWidth(result) {
    this.props[ats.SET_IS_RESPONSIVE]({ isResponsiveWidth: result });
  }

  render() {
    return this.props.children;
  }
}

export default connect(null, bindActions)(ResponsiveWidthMonitor);
